module.exports = __webpack_public_path__ + "static/client_2-4982223501df945ef2ddd5a23fe55734.png";